import type { ChatVectorIndexOption } from "src/db";

const normalize = (value: string | null | undefined): string =>
    (value ?? "").toLowerCase().replace(/[_\s]/g, "");

export const matchesUserRole = ({
    option,
    userRoles,
}: {
    option: ChatVectorIndexOption;
    userRoles: string[];
}): boolean =>
    userRoles.some((role) => {
        const normalizedRole = normalize(role);
        const datasourceLabel = normalize(option.datasource_label);
        const indexLabel = normalize(option.label);
        return (
            normalizedRole.includes(datasourceLabel) ||
            datasourceLabel.includes(normalizedRole) ||
            normalizedRole.includes(indexLabel) ||
            indexLabel.includes(normalizedRole) ||
            normalizedRole === normalize(option.datasource_id)
        );
    });
